
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import Read from "./read.vue";
import TimeRange from "../time-range/time-range.vue";
import { PostDeviceList } from "@/request/workstation";
@Component({
  components: {
    Read,
    TimeRange,
  },
})
export default class Name extends mixins(listMixin) {
  @Prop()
  private part: any;
  @Watch("part", { immediate: true })
  private partChange() {
    if (this.part === "血糖") {
      this.readId = "";
      this.getList();
    }
  }
  private ifShowRead: any = false;
  private data: any = [];
  private readId: any = "";
  private get patient() {
    return this.$store.state.patient;
  }
  private goRead(item: any) {
    this.readId = item.date;
    this.ifShowRead = true;
  }
  private timeChange(d: any) {
    this.filters = JSON.parse(JSON.stringify(d));
    this.search();
  }
  getList() {
    this.data = [];
    const params: any = {
      patient_id: this.patient.patient_id,
      type: "血糖",
      begin_date: this.filters.startTime,
      end_date: this.filters.endTime,
      current_page: this.filters.current_page,
      page_count: this.filters.page_count,
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    PostDeviceList(this, params)
      .then((data: any) => {
        loading.close();
        this.data = data.datas;
        this.filters.total_count = data.total_count;
        this.filters.total_page = data.total_page;
        if (this.data.length === 0) {
          this.ifShowEmpty = true;
        } else {
          this.ifShowEmpty = false;
        }
      })
      .catch(() => {
        loading.close();
      });
  }
}
